import { Footer } from "../../common";
import { FormBuilder } from "../FormBuilder/FormBuilder";
import { FormFailure } from "./FormStates/FailureState/FormFailure";
import { FormSuccess } from "./FormStates/SuccessState/FormSuccess";
import { usePlatformList } from "./FormStates/SuccessState/FormSuccess.hooks";
import { STEPS_NUMBER } from "./ReviewForm.constants";
import { useReviewForm } from "./ReviewForm.hooks";
import { Container, MainContainer } from "./ReviewForm.styles";

export const ReviewForm = () => {
  const { states, actions } = useReviewForm();
  const platformList = usePlatformList();
  const { formSubmitState, activeForm, activeStepIndex, defaultValues, formData } = states;
  const { handleSubmit, handleNewReview, handleBack, handleYes, onChange } = actions;

  return activeForm ? (
    <MainContainer>
      <Container>
        {formSubmitState === undefined ? (
          <FormBuilder
            activeStepIndex={activeStepIndex}
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
            steps={STEPS_NUMBER}
            onBack={handleBack}
            onChange={onChange}
            formData={formData}
            {...activeForm}
          />
        ) : formSubmitState === true ? (
          <FormSuccess onYes={handleNewReview} platformList={platformList} />
        ) : (
          <FormFailure onYes={handleYes} />
        )}
      </Container>
      <Footer />
    </MainContainer>
  ) : null;
};
